<template>
  <div class="permissions" v-loading="loading">
    <div class="permissions-first">管理员添加</div>
    <div class="permissions-second">
      <div
        class="permissions-second-list"
        v-for="(item, index) in 3"
        :key="index"
      >
        <div class="permissions-second-list-title">
          {{
            index == 0
              ? 'id名称'
              : index == 1
              ? '手机号码'
              : index == 2
              ? 'id密码'
              : ''
          }}
        </div>
        <div class="permissions-second-list-input">
          <el-input
            v-if="index == 0"
            placeholder="请输入id名称"
            v-model="idName"
            clearable
          >
          </el-input>

          <el-input
            v-if="index == 1"
            placeholder="请输入手机号码"
            v-model="idPhone"
            clearable
          >
          </el-input>

          <el-input
            v-if="index == 2"
            :placeholder="idName == '' ? '请添加id密码' : '请重新设置id密码'"
            v-model="idPassword"
            clearable
          >
          </el-input>
        </div>
      </div>
    </div>

    <div class="permissions-thirdly">
      <div class="permissions-thirdly-title">职位描述</div>
      <div class="permissions-thirdly-textarea">
        <el-input
          type="textarea"
          placeholder="请输入职位描述（选填）"
          v-model="positionTextarea"
          maxlength=""
          show-word-limit
        >
        </el-input>
      </div>
    </div>

    <div class="permissions-fourthly">
      <div class="permissions-fourthly-title">权限设置</div>

      <div class="permissions-fourthly-block">
        <div class="fourthly-block-dealModule">
          <div class="dealModule-title">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选
            </el-checkbox>
          </div>

          <div class="dealModule-display">
            <div
              class="dealModule-display-transaction"
              v-for="(item, index) in 10"
              :key="index"
            >
              <div class="transaction-place" v-if="index == 0">
                <el-checkbox
                  :indeterminate="homeIsIndeterminate"
                  v-model="homeCheckAll"
                  @change="homeCheckAllChange"
                  >首页模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 0">
                <el-checkbox-group
                  v-model="homeCheckedCities"
                  @change="homeCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in homeList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 1">
                <el-checkbox
                  :indeterminate="transactionIsIndeterminate"
                  v-model="transactionCheckAll"
                  @change="transactionCheckAllChange"
                  >交易管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 1">
                <el-checkbox-group
                  v-model="transactionCheckedCities"
                  @change="transactionCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in ransactionList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 2">
                <el-checkbox
                  :indeterminate="userIsIndeterminate"
                  v-model="userCheckAll"
                  @change="userCheckAllChange"
                  >用户管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 2">
                <el-checkbox-group
                  v-model="userCheckedCities"
                  @change="userCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in userList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 3">
                <el-checkbox
                  :indeterminate="partnerIsIndeterminate"
                  v-model="partnerCheckAll"
                  @change="partnerCheckAllChange"
                  >合伙人管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 3">
                <el-checkbox-group
                  v-model="partnerCheckedCities"
                  @change="partnerCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in partnerList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 4">
                <el-checkbox
                  :indeterminate="auditIsIndeterminate"
                  v-model="auditCheckAll"
                  @change="auditCheckAllChange"
                  >审核管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 4">
                <el-checkbox-group
                  v-model="auditCheckedCities"
                  @change="auditCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in auditList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 5">
                <el-checkbox
                  :indeterminate="activityIsIndeterminate"
                  v-model="activityCheckAll"
                  @change="activityCheckAllChange"
                  >活动设置管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 5">
                <el-checkbox-group
                  v-model="activityCheckedCities"
                  @change="activityCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in activityList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 6">
                <el-checkbox
                  :indeterminate="marketingIsIndeterminate"
                  v-model="marketingCheckAll"
                  @change="marketingCheckAllChange"
                  >营销中心</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 6">
                <el-checkbox-group
                  v-model="marketingCheckedCities"
                  @change="marketingCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in marketingList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 7">
                <el-checkbox
                  :indeterminate="supplierIsIndeterminate"
                  v-model="supplierCheckAll"
                  @change="supplierCheckAllChange"
                  >供应商管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 7">
                <el-checkbox-group
                  v-model="supplierCheckedCities"
                  @change="supplierCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in supplierList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 8">
                <el-checkbox
                  :indeterminate="basicsIsIndeterminate"
                  v-model="basicsCheckAll"
                  @change="basicsCheckAllChange"
                  >基础设置模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 8">
                <el-checkbox-group
                  v-model="basicsCheckedCities"
                  @change="basicsCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in basicsList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>

              <div class="transaction-place" v-if="index == 9">
                <el-checkbox
                  :indeterminate="commodityIsIndeterminate"
                  v-model="commodityCheckAll"
                  @change="commodityCheckAllChange"
                  >商品管理模块</el-checkbox
                >
              </div>
              <div class="transaction-list" v-if="index == 9">
                <el-checkbox-group
                  v-model="commodityCheckedCities"
                  @change="commodityCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in commodityList"
                    :key="index"
                    :label="item"
                  >
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="permissions-fifth" @click="submitRole">确定</div>
  </div>
</template>

<script>
import { getAdminListDetail, postAdminListAdd } from '../../api/role'

import Bus from '../../utils/bus' // bus发送跳转关闭临时组件

// 权限  首页
const homeOptions = [
  {
    title: '首页页面展示',
    value: 'HOME_SHOW',
  },
  {
    title: '首页页面展示',
    value: 'HOME_FUNC',
  },
]

// 权限  第一模块  交易管理模块
const transactionOptions = [
  {
    title: '销售订单页面展示',
    value: 'MARKET_ORDER_SHOW',
  },
  {
    title: '销售订单功能',
    value: 'MARKET_ORDER_FUNC',
  },
  {
    title: '积分订单页面展示',
    value: 'INTEGRAL_ORDER_SHOW',
  },
  {
    title: '积分订单功能',
    value: 'INTEGRAL_ORDER_FUNC',
  },
  {
    title: '售后订单页面展示',
    value: 'AFTER_ORDER_SHOW',
  },
  {
    title: '售后订单功能',
    value: 'AFTER_ORDER_FUNC',
  },
  {
    title: 'VIP订单页面展示',
    value: 'VIP_ORDER_SHOW',
  },
  {
    title: 'VIP订单功能',
    value: 'VIP_ORDER_FUNC',
  },
]

//  权限  第二模块  用户管理模块
const userOptions = [
  {
    title: '用户查看页面展示',
    value: 'USER_CHECK_SHOW',
  },
  {
    title: '用户查看功能',
    value: 'USER_CHECK_FUNC',
  },
  {
    title: '用户数据统计页面展示',
    value: 'USER_STATISTICS_SHOW',
  },
]
//  权限  第三模块  活动设置管理管理模块
const activityOptions = [
  {
    title: '大转盘设置页面展示',
    value: 'WHEEL_SET_SHOW',
  },
  {
    title: '大转盘设置功能',
    value: 'WHEEL_SET_FUNC',
  },
  {
    title: '大转盘中奖明细页面展示',
    value: 'WHEEL_DETAIL_SHOW',
  },
  {
    title: '大转盘中奖明细功能',
    value: 'WHEEL_DETAIL_FUNC',
  },
  {
    title: '积分兑换红包设置页面展示',
    value: 'INTEGRAL_RED_SHOW',
  },
  {
    title: '积分红包兑换设置功能',
    value: 'INTEGRAL_RED_FUNC',
  },
  {
    title: '积分红包兑换明细页面展示',
    value: 'INTEGRAL_RED_DETAIL_SHOW',
  },
  {
    title: '积分红包兑换明细功能',
    value: 'INTEGRAL_RED_DETAIL_FUNC',
  },
  {
    title: '每日爆品页面展示',
    value: 'DAY_EXPLOSIVE_SHOW',
  },
  {
    title: '每日爆品功能',
    value: 'DAY_EXPLOSIVE_FUNC',
  },
  {
    title: '限时秒杀页面展示',
    value: 'TIME_SECKIL_SHOW',
  },
  {
    title: '限时秒杀功能',
    value: 'TIME_SECKIL_FUNC',
  },
]
//  权限  第四模块  营销中心
const marketingOptions = [
  {
    title: '首页轮播图页面展示',
    value: 'HOME_SWIPER_SHOW',
  },
  {
    title: '首页轮播图功能',
    value: 'HOME_SWIPER_FUNC',
  },
  {
    title: '金刚区管理页面展示',
    value: 'KONG_KIM_SHOW',
  },
  {
    title: '金刚区管理功能',
    value: 'KONG_KIM_FUNC',
  },
]
//  权限  第五模块  供应商管理模块
const supplierOptions = [
  {
    title: '供应商管理页面展示',
    value: 'SUPPLIER_ADMINISTRATION_SHOW',
  },
  {
    title: '供应商管理功能',
    value: 'SUPPLIER_ADMINISTRATION_FUNC',
  },
]
//  权限  第六模块  基础设置模块
const basicsOptions = [
  {
    title: '系统通知页面展示',
    value: 'SYSTEMATIC_NOTIFICATION_SHOW',
  },
  {
    title: '系统通知功能',
    value: 'SYSTEMATIC_NOTIFICATION_FUNC',
  },
  {
    title: '关于我们页面展示',
    value: 'ABOUT_US_SHOW',
  },
  {
    title: '关于我们功能',
    value: 'ABOUT_US_FUNC',
  },

  {
    title: '帮助中心页面展示',
    value: 'HELP_CENTER_SHOW',
  },
  {
    title: '帮助中心功能',
    value: 'HELP_CENTER_FUNC',
  },
  {
    title: '协议管理页面展示',
    value: 'AGREEMENT_ADMINISTRATION_SHOW',
  },
  {
    title: '协议管理功能',
    value: 'AGREEMENT_ADMINISTRATION_FUNC',
  },
  {
    title: '敏感词屏蔽管理页面展示',
    value: 'SENSITIVE_MASKING_SHOW',
  },
  {
    title: '敏感词屏蔽管理功能',
    value: 'SENSITIVE_MASKING_FUNC',
  },
  {
    title: '联系我们页面展示',
    value: 'CONTACT_US_SHOW',
  },
  {
    title: '联系我们功能',
    value: 'CONTACT_US_FUNC',
  },
  {
    title: '搜索设置管理页面展示',
    value: 'SEARCH_ADMINISTRATION_SHOW',
  },
  {
    title: '搜索设置管理功能',
    value: 'SEARCH_ADMINISTRATION_FUNC',
  },
  {
    title: 'APP管理管理页面展示',
    value: 'SEARCH_VERSIONS_SHOW',
  },
  {
    title: 'APP管理管理功能',
    value: 'SEARCH_VERSIONS_FUNC',
  },
]
//  权限  第七模块  商品管理模块
const commodityOptions = [
  {
    title: '商品分类页面展示',
    value: 'COMMONDITY_CLASSFIY_SHOW',
  },
  {
    title: '商品分类功能',
    value: 'COMMONDITY_CLASSFIY_FUNC',
  },
  {
    title: '销售商品页面展示',
    value: 'MARKET_COMMONDITY_SHOW',
  },
  {
    title: '销售商品功能',
    value: 'MARKET_COMMONDITY_FUNC',
  },
  {
    title: '积分商品页面展示',
    value: 'INTEGRAL_COMMONDITY_SHOW',
  },
  {
    title: '积分商品功能',
    value: 'INTEGRAL_COMMONDITY_FUNC',
  },
]
//新加
// 权限  第八模块  合伙人管理
const partnerOptions = [
  {
    title: '合伙人账号页面展示',
    value: 'PARTNER_ACCOUNT_SHOW',
  },
  {
    title: '合伙人账号功能',
    value: 'PARTNER_ACCOUNT_FUNC',
  },
  {
    title: '合伙人收入页面展示',
    value: 'PARTNER_INCOME_SHOW',
  },
  {
    title: '合伙人收入功能',
    value: 'PARTNER_INCOME_FUNC',
  },
  {
    title: '合伙人系统变量页面展示',
    value: 'PARTNER_SYSTEM_SHOW',
  },
  {
    title: '合伙人系统变量功能',
    value: 'PARTNER_SYSTEM_FUNC',
  },
  {
    title: '合伙人审核页面展示',
    value: 'AUDIT_PARTNER_SHOW',
  },
  {
    title: '合伙人审核页面功能',
    value: 'AUDIT_PARTNER_FUNC',
  },
  {
    title: '合伙人提现页面展示',
    value: 'AUDIT_PARTNERWITHDRAW_SHOW',
  },
  {
    title: '合伙人提现页面功能',
    value: 'AUDIT_PARTNERWITHDRAW_FUNC',
  },
  {
    title: '合伙人保证金申请页面展示',
    value: 'AUDIT_PARTNERCASH_SHOW',
  },
  {
    title: '合伙人保证金申请页面功能',
    value: 'AUDIT_PARTNERCASH_FUNC',
  },
  {
    title: '合伙人提取保证金页面展示',
    value: 'AUDIT_CASHEXTRACT_SHOW',
  },
  {
    title: '合伙人提取保证金页面功能',
    value: 'AUDIT_CASHEXTRACT_FUNC',
  },
]

// 权限  第九模块  合伙人管理
const auditOptions = [
  {
    title: '实名认证页面展示',
    value: 'AUDIT_AUTONYM_SHOW',
  },
  {
    title: '实名认证页面功能',
    value: 'AUDIT_AUTONYM_FUNC',
  },
  {
    title: '支付宝审核页面展示',
    value: 'AUDIT_ALIPAY_SHOW',
  },
  {
    title: '支付宝审核页面功能',
    value: 'AUDIT_ALIPAY_FUNC',
  },
  {
    title: '银行卡审核页面展示',
    value: 'AUDIT_BANK_SHOW',
  },
  {
    title: '银行卡审核页面功能',
    value: 'AUDIT_BANK_FUNC',
  },
  {
    title: '提现审核页面展示',
    value: 'AUDIT_WITHDRAW_SHOW',
  },
  {
    title: '提现审核页面功能',
    value: 'AUDIT_WITHDRAW_FUNC',
  },
]

export default {
  data() {
    return {
      // 用户名  id名称
      idName: '',
      // 昵称
      idnickName: '',
      // id手机号
      idPhone: '',
      // id密码
      idPassword: '',
      // 职位描述
      positionTextarea: '',
      // 当前管理员的id
      roleId: '',
      // 数组合并暂时缓存数组
      countArray: [],
      // 汇总所有页面数组
      roleCollectArray: [],
      // 进入存储数组权限设置
      roleCollectList: [],
      // 监听用户刷新
      loading: false,
      // 权限设置
      //************************* */
      // 权限设置第一模块 交易管理模块 总和 一键合并
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      // 权限设置 首页
      homeCheckAll: false,
      homeCheckedCities: [],
      homeList: homeOptions,
      homeIsIndeterminate: true,
      // 权限设置第一模块 交易管理模块
      transactionCheckAll: false,
      transactionCheckedCities: [],
      ransactionList: transactionOptions,
      transactionIsIndeterminate: true,
      // 权限设置第二模块 用户管理权限
      userCheckAll: false,
      userCheckedCities: [],
      userList: userOptions,
      userIsIndeterminate: true,
      // 权限设置第三模块 活动设置管理
      activityCheckAll: false,
      activityCheckedCities: [],
      activityList: activityOptions,
      activityIsIndeterminate: true,
      // 权限设置第四模块 营销中心
      marketingCheckAll: false,
      marketingCheckedCities: [],
      marketingList: marketingOptions,
      marketingIsIndeterminate: true,
      // 权限设置第五模块 供应商管理模块
      supplierCheckAll: false,
      supplierCheckedCities: [],
      supplierList: supplierOptions,
      supplierIsIndeterminate: true,
      // 权限设置第六模块 基础设置模块
      basicsCheckAll: false,
      basicsCheckedCities: [],
      basicsList: basicsOptions,
      basicsIsIndeterminate: true,
      // 权限设置第七模块 商品管理模块
      commodityCheckAll: false,
      commodityCheckedCities: [],
      commodityList: commodityOptions,
      commodityIsIndeterminate: true,
      // 权限设置第八模块 合伙人管理模块
      partnerCheckAll: false,
      partnerCheckedCities: [],
      partnerList: partnerOptions,
      partnerIsIndeterminate: true,
      // 权限设置第九模块 合伙人管理模块
      auditCheckAll: false,
      auditCheckedCities: [],
      auditList: auditOptions,
      auditIsIndeterminate: true,
    }
  },
  created() {
    // 获取管理员id
    console.log('查看', this.$route.query.id)
    if (this.$route.query.id != undefined) {
      this.roleId = this.$route.query.id
      this.loading = true
      this.getAdminListDetailClick()
    }
  },
  methods: {
    // 获取管理员详情
    getAdminListDetailClick() {
      let params = this.roleId

      getAdminListDetail(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('接口返回', res)
          // 管理员id名称
          this.idName = res.resultData.userName
          // 手机号
          this.idPhone = res.resultData.phone
          // 昵称
          this.idnickName = res.resultData.nickname
          // 职位描述
          this.positionTextarea = res.resultData.positionDesc

          // 权限组查看
          this.roleCollectList =
            res.resultData.resource == null
              ? []
              : res.resultData.resource.split(';')

          this.loading = false

          this.roleCollectClick()
        }
      })
    },

    // 权限设置 第一模块 全选
    handleCheckAllChange(val) {
      if (val == false) {
        this.homeCheckedCities = []
        this.transactionCheckedCities = []
        this.userCheckedCities = []
        this.activityCheckedCities = []
        this.marketingCheckedCities = []
        this.supplierCheckedCities = []
        this.basicsCheckedCities = []
        this.commodityCheckedCities = []
        this.partnerCheckedCities = []
        this.auditCheckedCities = []

        this.isIndeterminate = true

        this.homeCheckAll = false
        this.transactionCheckAll = false
        this.userCheckAll = false
        this.activityCheckAll = false
        this.marketingCheckAll = false
        this.supplierCheckAll = false
        this.basicsCheckAll = false
        this.commodityCheckAll = false
        this.partnerCheckAll = false
        this.auditCheckAll = false

        this.homeIsIndeterminate = true
        this.transactionIsIndeterminate = true
        this.userIsIndeterminate = true
        this.activityIsIndeterminate = true
        this.marketingIsIndeterminate = true
        this.supplierIsIndeterminate = true
        this.basicsIsIndeterminate = true
        this.commodityIsIndeterminate = true
        this.partnerIsIndeterminate = true
        this.auditIsIndeterminate = true
      } else {
        this.homeCheckedCities = homeOptions
        this.transactionCheckedCities = transactionOptions
        this.userCheckedCities = userOptions
        this.activityCheckedCities = activityOptions
        this.marketingCheckedCities = marketingOptions
        this.supplierCheckedCities = supplierOptions
        this.basicsCheckedCities = basicsOptions
        this.commodityCheckedCities = commodityOptions
        this.partnerCheckedCities = partnerOptions
        this.auditCheckedCities = auditOptions

        this.homeCheckAll = true
        this.transactionCheckAll = true
        this.userCheckAll = true
        this.activityCheckAll = true
        this.marketingCheckAll = true
        this.supplierCheckAll = true
        this.basicsCheckAll = true
        this.commodityCheckAll = true
        this.partnerCheckAll = true
        this.auditCheckAll = true

        this.homeIsIndeterminate = false
        this.transactionIsIndeterminate = false
        this.userIsIndeterminate = false
        this.activityIsIndeterminate = false
        this.marketingIsIndeterminate = false
        this.supplierIsIndeterminate = false
        this.basicsIsIndeterminate = false
        this.commodityIsIndeterminate = false
        this.partnerIsIndeterminate = false
        this.auditIsIndeterminate = false

        this.isIndeterminate = false
        this.checkAll = true
      }
    },

    // 设置一个方法进行调用判断  这三个值是否都是true
    dealAllBtn() {
      if (
        this.homeCheckAll == true &&
        this.transactionCheckAll == true &&
        this.userCheckAll == true &&
        this.activityCheckAll == true &&
        this.marketingCheckAll == true &&
        this.supplierCheckAll == true &&
        this.basicsCheckAll == true &&
        this.commodityCheckAll == true
      ) {
        this.isIndeterminate = false
        this.checkAll = true
      } else {
        this.isIndeterminate = true
        this.checkAll = false
      }
    },

    // 权限设置 首页模块
    homeCheckAllChange(val) {
      this.homeCheckedCities = val ? homeOptions : []
      this.homeIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第一模块 交易管理模块 单独选中
    homeCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.homeCheckAll = checkedCount === this.homeList.length
      this.homeIsIndeterminate =
        checkedCount > 0 && checkedCount < this.homeList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第一模块 交易管理模块 全选
    transactionCheckAllChange(val) {
      this.transactionCheckedCities = val ? transactionOptions : []
      this.transactionIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第一模块 交易管理模块 单独选中
    transactionCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.transactionCheckAll = checkedCount === this.ransactionList.length
      this.transactionIsIndeterminate =
        checkedCount > 0 && checkedCount < this.ransactionList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第二模块 用户管理权限 全选
    userCheckAllChange(val) {
      this.userCheckedCities = val ? userOptions : []
      this.userIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第二模块 用户管理权限 单独选中
    userCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.userCheckAll = checkedCount === this.userList.length
      this.userIsIndeterminate =
        checkedCount > 0 && checkedCount < this.userList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第三模块 活动设置管理 全选
    activityCheckAllChange(val) {
      this.activityCheckedCities = val ? activityOptions : []
      this.activityIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第三模块 活动设置管理 单独选中
    activityCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.activityCheckAll = checkedCount === this.activityList.length
      this.activityIsIndeterminate =
        checkedCount > 0 && checkedCount < this.activityList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第四模块 营销中心 全选
    marketingCheckAllChange(val) {
      this.marketingCheckedCities = val ? marketingOptions : []
      this.marketingIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第四模块 营销中心 单独选中
    marketingCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.marketingCheckAll = checkedCount === this.marketingList.length
      this.marketingIsIndeterminate =
        checkedCount > 0 && checkedCount < this.marketingList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第五模块 营销中心 全选
    supplierCheckAllChange(val) {
      this.supplierCheckedCities = val ? supplierOptions : []
      this.supplierIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第五模块 营销中心 单独选中
    supplierCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.supplierCheckAll = checkedCount === this.supplierList.length
      this.supplierIsIndeterminate =
        checkedCount > 0 && checkedCount < this.supplierList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第六模块 基础设置模块 全选
    basicsCheckAllChange(val) {
      this.basicsCheckedCities = val ? basicsOptions : []
      this.basicsIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第六模块 基础设置模块 单独选中
    basicsCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.basicsCheckAll = checkedCount === this.basicsList.length
      this.basicsIsIndeterminate =
        checkedCount > 0 && checkedCount < this.basicsList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第七模块 商品管理模块 全选
    commodityCheckAllChange(val) {
      this.commodityCheckedCities = val ? commodityOptions : []
      this.commodityIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第七模块 商品管理模块 单独选中
    commodityCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.commodityCheckAll = checkedCount === this.commodityList.length
      this.commodityIsIndeterminate =
        checkedCount > 0 && checkedCount < this.commodityList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第八模块 合伙人管理模块 全选
    partnerCheckAllChange(val) {
      this.partnerCheckedCities = val ? partnerOptions : []
      this.partnerIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第八模块 合伙人管理模块 单独选中
    partnerCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.partnerCheckAll = checkedCount === this.partnerList.length
      this.partnerIsIndeterminate =
        checkedCount > 0 && checkedCount < this.partnerList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    // 权限设置 第八模块 合伙人管理模块 全选
    auditCheckAllChange(val) {
      this.auditCheckedCities = val ? auditOptions : []
      this.auditIsIndeterminate = false
      // 每次点击都要进行判断
      this.dealAllBtn()
    },
    // 权限设置 第九模块 合伙人管理模块 单独选中
    auditCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.auditCheckAll = checkedCount === this.auditList.length
      this.auditIsIndeterminate =
        checkedCount > 0 && checkedCount < this.auditList.length
      // 每次点击都要进行判断
      this.dealAllBtn()
    },

    /*****************汇总算法*************** */
    roleCollectClick() {
      this.roleCollectArray = transactionOptions.concat(
        userOptions,
        activityOptions,
        marketingOptions,
        supplierOptions,
        basicsOptions,
        commodityOptions,
        partnerOptions,
        auditOptions,
        homeOptions
      )

      console.log('进入后默认汇总数组', this.roleCollectArray)

      if (this.roleCollectArray.length == this.roleCollectList.length) {
        // 数组长度一致则直接默认全部勾选
        this.handleCheckAllChange(true)
      } else {
        // 数组长度不一致
        this.handleCheckAllChange(false)
        // 通过接口返回的数组进行
        this.roleCollectList.forEach((item, index) => {
          //   console.log('总数据', item)

          // 判断首页模块中是否全部存在
          for (let i = 0; i < homeOptions.length; i++) {
            if (item == homeOptions[i].value) {
              this.homeCheckedCities.push(homeOptions[i])
              if (this.homeCheckedCities.length == homeOptions.length) {
                this.homeCheckAll = true
                this.homeIsIndeterminate = false
              }
            }
          }

          // 判断第一模块中是否全部存在
          for (let i = 0; i < transactionOptions.length; i++) {
            if (item == transactionOptions[i].value) {
              this.transactionCheckedCities.push(transactionOptions[i])
              if (
                this.transactionCheckedCities.length ==
                transactionOptions.length
              ) {
                this.transactionCheckAll = true
                this.transactionIsIndeterminate = false
              }
            }
          }

          // 判断第二模块中是否全部存在
          for (let i = 0; i < userOptions.length; i++) {
            if (item == userOptions[i].value) {
              this.userCheckedCities.push(userOptions[i])
              if (this.userCheckedCities.length == userOptions.length) {
                this.userCheckAll = true
                this.userIsIndeterminate = false
              }
            }
          }

          // 判断第三模块中是否全部存在
          for (let i = 0; i < activityOptions.length; i++) {
            if (item == activityOptions[i].value) {
              this.activityCheckedCities.push(activityOptions[i])

              if (this.activityCheckedCities.length == activityOptions.length) {
                this.activityCheckAll = true
                this.activityIsIndeterminate = false
              }
            }
          }

          // 判断第四模块中是否全部存在
          for (let i = 0; i < marketingOptions.length; i++) {
            if (item == marketingOptions[i].value) {
              this.marketingCheckedCities.push(marketingOptions[i])

              if (
                this.marketingCheckedCities.length == marketingOptions.length
              ) {
                this.marketingCheckAll = true
                this.marketingIsIndeterminate = false
              }
            }
          }

          // 判断第五模块中是否全部存在
          for (let i = 0; i < supplierOptions.length; i++) {
            if (item == supplierOptions[i].value) {
              this.supplierCheckedCities.push(supplierOptions[i])

              if (this.supplierCheckedCities.length == supplierOptions.length) {
                this.supplierCheckAll = true
                this.supplierIsIndeterminate = false
              }
            }
          }

          // 判断第六模块中是否全部存在
          for (let i = 0; i < basicsOptions.length; i++) {
            if (item == basicsOptions[i].value) {
              this.basicsCheckedCities.push(basicsOptions[i])

              if (this.basicsCheckedCities.length == basicsOptions.length) {
                this.basicsCheckAll = true
                this.basicsIsIndeterminate = false
              }
            }
          }

          // 判断第七模块中是否全部存在
          for (let i = 0; i < commodityOptions.length; i++) {
            if (item == commodityOptions[i].value) {
              this.commodityCheckedCities.push(commodityOptions[i])

              if (
                this.commodityCheckedCities.length == commodityOptions.length
              ) {
                this.commodityCheckAll = true
                this.commodityIsIndeterminate = false
              }
            }
          }

          // 判断第八模块中是否全部存在
          for (let i = 0; i < partnerOptions.length; i++) {
            if (item == partnerOptions[i].value) {
              this.partnerCheckedCities.push(partnerOptions[i])

              if (this.partnerCheckedCities.length == partnerOptions.length) {
                this.partnerCheckAll = true
                this.partnerIsIndeterminate = false
              }
            }
          }

          // 判断第九模块中是否全部存在
          for (let i = 0; i < auditOptions.length; i++) {
            if (item == auditOptions[i].value) {
              this.auditCheckedCities.push(auditOptions[i])

              if (this.auditCheckedCities.length == auditOptions.length) {
                this.auditCheckAll = true
                this.auditIsIndeterminate = false
              }
            }
          }
        })
      }
    },

    /*---------------权限提交确定------------------------ */
    submitRole() {
      // 首页模块
      console.log('点击确定', this.homeCheckedCities)
      // 交易模块
      console.log('点击确定', this.transactionCheckedCities)
      // 用户管理权限
      console.log('点击确定', this.userCheckedCities)
      // 活动设置管理
      console.log('点击确定', this.activityCheckedCities)
      // 营销中心
      console.log('点击确定', this.marketingCheckedCities)
      // 供应商管理模块
      console.log('点击确定', this.supplierCheckedCities)
      // 基础设置模块
      console.log('点击确定', this.basicsCheckedCities)
      // 商品管理模块
      console.log('点击确定', this.commodityCheckedCities)
      // 合伙人管理模块
      console.log('点击确定', this.partnerCheckedCities)
      // 审核管理模块
      console.log('点击确定', this.auditCheckedCities)

      // 第一步合并数组进行排序分配

      this.countArray = this.transactionCheckedCities.concat(
        this.userCheckedCities,
        this.activityCheckedCities,
        this.marketingCheckedCities,
        this.supplierCheckedCities,
        this.basicsCheckedCities,
        this.commodityCheckedCities,
        this.partnerCheckedCities,
        this.auditCheckedCities,
        this.homeCheckedCities
      )

      console.log('是否合并成一个数组', this.countArray)
      let commodityIds = this.countArray
        .map((item) => {
          return item.value
        })
        .join(';')

      let params = {
        id: this.roleId, // 管理员id
        userName: this.idName, // 用户名 id名称
        nickname: this.idnickName, // 昵称
        phone: this.idPhone, //  手机号码
        position: '', //  职位 暂不显示
        positionDesc: this.positionTextarea, // 职位描述
        resource: commodityIds, // 资源组
        password: this.idPassword, // 密码 如果是修改,则可传空，代表不修改密码，若输入，则视为修改密码
      }

      console.log('勾选所有的权限', params)
      postAdminListAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: this.roleId == '' ? '新增成功！' : '修改成功！',
            type: 'success',
            duration: 2000,
          })

          Bus.$emit('detele', 'roleAdd')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.permissions {
  height: 1100px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
  padding: 26px 24px;
  box-sizing: border-box;

  .permissions-first {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #222222;
  }

  .permissions-second {
    display: flex;
    margin-top: 24px;

    .permissions-second-list {
      margin-right: 66px;

      .permissions-second-list-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .permissions-second-list-input {
        width: 100%;
        margin-top: 4px;

        /deep/ .el-input {
          height: 32px;
          width: 270px;
        }

        /deep/ .el-input__inner {
          padding: 0 10px;
          box-sizing: border-box;
          height: 32px;
          background-color: rgba(255, 255, 255, 0);
        }

        /deep/ .el-select .el-input.is-focus .el-input__inner {
          border-color: rgba(217, 217, 217, 1);
        }
      }
    }

    .permissions-second-list:last-child {
      margin-right: 0;
    }
  }

  .permissions-thirdly {
    margin-top: 22px;

    .permissions-thirdly-title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .permissions-thirdly-textarea {
      margin-top: 4px;
      width: 606px;
      height: 110px;
      background: #ffffff;
      border-radius: 5px;

      /deep/ .el-textarea {
        height: 100%;
        cursor: pointer;
      }

      /deep/ .el-textarea__inner {
        height: 100%;
        padding: 10px 10px 20px;
      }

      /deep/ .el-textarea .el-textarea__inner {
        // 然后找到对应的类名，在这里将拉伸去掉即可
        resize: none;
      }
    }
  }

  .permissions-fourthly {
    margin-top: 21px;
    border-top: 1px solid #edeff7;
    padding-top: 24px;
    box-sizing: border-box;

    .permissions-fourthly-title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .permissions-fourthly-block {
      height: 660px;
      border: 1px solid #e8e8e8;
      margin-top: 4px;
      padding: 19px 17px;
      box-sizing: border-box;

      .fourthly-block-dealModule {
        .dealModule-title {
          /deep/ .el-checkbox__label {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }

        .dealModule-display {
          margin-top: 11px;

          .dealModule-display-transaction {
            width: 100%;
            display: flex;
            border: 1px solid #e8e8e8;

            .transaction-place {
              background: #fafafa;
              display: flex;
              align-items: center;
              justify-content: center;

              /deep/ .el-checkbox {
                width: 180px;
                margin-right: 8px;
                display: flex;
                align-items: center;
                background: #fafafa;
                padding-left: 16px;
              }
            }

            .transaction-list {
              display: flex;

              /deep/ .el-checkbox {
                height: 46px;
                margin-right: 8px;
                display: flex;
                padding-left: 16px;
                align-items: center;
              }

              /deep/ .el-checkbox:last-child {
                margin-right: 0;
              }

              /deep/ .el-checkbox-group {
                display: flex;
                flex-wrap: wrap;
              }
            }
          }
        }
      }
    }
  }

  .permissions-fifth {
    width: 88px;
    height: 36px;
    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
    border-radius: 10px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-top: 23px;
    cursor: pointer;
  }
}
</style>
